import styled from 'styled-components';
import { Palette } from 'config';

export const Container = styled.div`
  margin-top: 100px;
  display: flex;
  flex-direction: column;

  padding-left: 10%;
  h1 {
    color: ${Palette.PrimaryGray._900};
    font-size: 2.5em;
    font-weight: 700;
    line-height: 48px;
    width: 63%;
    margin: 0 auto 48px;
  }
`;

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-self: center;
`;

export const Wrap = styled.div`
  display: flex;
`;

export const ListPosition = styled.div`
  margin-right: 32px;
  width: 15%;
  min-width: 167px;
`;
